export const mapSelect = (originTree) => {
    const res = originTree.map((item, index) => ({
        key: item.role_id,
        id: item.role_id,
        label: item.name,
        type: item.type
    }));
    return res;
};
export const mapTree = (originTree, disabledAll = false) => {
    if (originTree?.length > 0) {
        const res = originTree.map((item, index) => ({
            key: item.code,
            id: item.code,
            label: item.name,
            children: mapTree(item.subPermissions, disabledAll),
            disabled: disabledAll
        }));
        return res;
    }
    else {
        return [];
    }
};
